"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPPOSITE_SIDES = exports.ANCHOR = void 0;

/**
 * Point anchors how cold be placed popover content relative to it's bounding element
 */
const ANCHOR = {
  left_top: 'left_top',
  center_top: 'center_top',
  right_top: 'right_top',
  left_center: 'left_center',
  right_center: 'right_center',
  left_bottom: 'left_bottom',
  center_bottom: 'center_bottom',
  right_bottom: 'right_bottom'
};
exports.ANCHOR = ANCHOR;
const OPPOSITE_SIDES = {
  left: 'right',
  top: 'bottom',
  right: 'left',
  bottom: 'top'
};
exports.OPPOSITE_SIDES = OPPOSITE_SIDES;